import { render } from "./ArchivedDocumentDetails.vue?vue&type=template&id=0be7e29c&scoped=true&ts=true&lang=pug"
import script from "./ArchivedDocumentDetails.vue?vue&type=script&lang=ts"
export * from "./ArchivedDocumentDetails.vue?vue&type=script&lang=ts"

import "./ArchivedDocumentDetails.vue?vue&type=style&index=0&id=0be7e29c&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be7e29c"]])

export default __exports__